export default __webpack_public_path__ + "static/media/banana2.6ea89e97.svg";